/*
 * @Author: Lina
 * @Date: 2020-06-29 19:32:06
 * @LastEditors: Lina
 * @LastEditTime: 2020-09-14 18:28:50
 */
const host = (window.crgt && window.crgt.isProd) ? 'https://static.ccrgt.com' : 'https://t-static.ccrgt.com';

export default {
  'netCar': {
    'type': 'navigateTo',
    'path': `${host}/FE-CARHAILING-H5/#/`,
    'params': {
      'channel': 'qa'
    },
    'isNativePage': false
  },
  'netCarOrder': {
    'type': 'navigateTo',
    'path': `${host}/FE-CARHAILING-H5/#/`,
    'params': {
      'channel': 'qa'
    },
    'isNativePage': false
  },
  'foodOrdering': {
    'type': 'navigateTo',
    'path': '/pages/order-meals',
    'params': {

    },
    'isNativePage': true
  },
  'ticket': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/index',
    'isNativePage': true
  },
  'ticketOrder': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/ticket-order-detail',
    'isNativePage': true
  },
  'video': null,
  'vipLounge': {
    'type': 'navigateTo',
    'path': `${host}/app-member/#/vip-lounge`,
    'params': {
      'channel': 'qa',
      'channelId': 507
    },
    'needLogin': true,
    'withToken': true,
    'isNativePage': false
  },
  'hotel': null,
  'phoneRecharge': {
    'type': 'navigateTo',
    'path': `${host}/phone-rechange/`,
    'params': {
      'channel': 'qa',
      '_crgtwv': 2,
      'source': 'mpicon'
    },
    'needLogin': true,
    'withToken': true,
    'isNativePage': false
  },
  'youzan': {
    'type': 'navigateTo',
    'path': 'https://h5.youzan.com/wscshop/showcase/homepage',
    'params': {
      'channel': 'qa',
      'kdt_id': '43018343'
    },
    'isNativePage': false
  },
  'youzanOrder': {
    'type': 'navigateTo',
    'path': 'https://h5.youzan.com/wscshop/showcase/homepage',
    'params': {
      'channel': 'qa',
      'kdt_id': '43018343'
    },
    'isNativePage': false
  },
  'rentCar': null,
  'redHat': null,
  'shareBus': null
}
